import { api } from './client'

/**
 * Видеозвонки (Jitsi).
 *
 * Пути повторяют роутер video.py. Гостевые ручки (guest, guestToken)
 * ходят без Authorization — гостевая страница живёт до логина,
 * axios-интерцептор просто не найдёт токена, и это нормально.
 */
export const videoApi = {
  // Настройки
  settings: () => api.get('/video/settings'),
  adminSettings: () => api.get('/admin/video/settings'),
  updateSettings: (data) => api.put('/admin/video/settings', data),

  // Звонки
  list: (status) => api.get('/video/calls', { params: status ? { status } : {} }),
  calendar: (from, to) => api.get('/video/calendar', { params: { from, to } }),
  staffSearch: (q) => api.get('/video/staff-search', { params: { q } }),
  get: (id) => api.get(`/video/calls/${id}`),
  create: (data) => api.post('/video/calls', data),
  update: (id, data) => api.patch(`/video/calls/${id}`, data),
  revoke: (id) => api.patch(`/video/calls/${id}`, { action: 'revoke' }),
  end: (id) => api.patch(`/video/calls/${id}`, { action: 'end' }),
  extend: (id, hours = 4) => api.patch(`/video/calls/${id}`, { extend_hours: hours }),

  // Вход: сотрудник (пароль нужен только чужому парольному звонку)
  token: (id, password) =>
    api.post(`/video/calls/${id}/token`, password ? { password } : {}),

  // Доклад о выходе: best-effort телеметрия для журнала и
  // автозавершения; сбой не мешает закрыть вкладку.
  leave: (id) => api.post(`/video/calls/${id}/leave`).catch(() => {}),

  // Фаза 2: записи (Jibri) и стоп-кадры видеоосмотра
  recordings: (id) => api.get(`/video/calls/${id}/recordings`),
  snapshot: (id, dataUrl) => api.post(`/video/calls/${id}/snapshot`, { image: dataUrl }),

  // Гости
  invites: (id, guests) => api.post(`/video/calls/${id}/invites`, { guests }),
  guestView: (id) => api.get(`/video/guest/${id}`),
  guestToken: (id, data) => api.post(`/video/calls/${id}/guest-token`, data),
}
